import { render, staticRenderFns } from "./bgSkeletonSSO.vue?vue&type=template&id=6b4809e9&scoped=true&"
import script from "./bgSkeletonSSO.vue?vue&type=script&lang=js&"
export * from "./bgSkeletonSSO.vue?vue&type=script&lang=js&"
import style0 from "./bgSkeletonSSO.vue?vue&type=style&index=0&id=6b4809e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4809e9",
  null
  
)

export default component.exports